import * as React from 'react';
import Dialog from './Dialog';
import DialogList from 'src/dialogs';
import ReactPDF from '@react-pdf/renderer';
import actions from 'src/actions';
import { connect } from 'react-redux';
import Button from '../controls/forms/redesign/FormButton';

export interface IPDFWindowDispatchProps {
    hideDialog: () => void;
}

export type IPDFWindowStateProps = {
    children?: React.ReactElement<ReactPDF.DocumentProps>;
    actionButtons?: Array<{ text: string; action?: () => void }>;
};

type IPDFWindowPageProps = IPDFWindowDispatchProps & IPDFWindowStateProps;

class PDFWindow extends React.Component<IPDFWindowPageProps> {
    displayActionButtons = () => {
        if (this.props.actionButtons?.length > 0) {
            return this.props.actionButtons.map((actionBtn, index) => {
                return (
                    <div key={index}>
                        <Button text={actionBtn.text} intent="primary" />
                    </div>
                );
            });
        }
        return (
            <div>
                <Button text="Something Else" intent="primary" />
            </div>
        );
    };

    pdfHeight = () => {
        return window.innerHeight * 0.8;
    };

    render() {
        return (
            <Dialog title="PDF Viewer" dialogName={DialogList.PDF_WINDOW} onCloseDialog={this.props.hideDialog}>
                <>
                    <ReactPDF.PDFViewer style={{ height: '80vh', width: '70vw' }}>{this.props.children}</ReactPDF.PDFViewer>

                    {/* 
                        Needs further development, may need later
                    <div>{this.displayActionButtons()}</div> */}
                </>
            </Dialog>
        );
    }
}

const mapDispatchToProps: IPDFWindowDispatchProps = {
    hideDialog: () => actions.layout.hideDialog(),
};

export default connect(null, mapDispatchToProps)(PDFWindow);



// WEBPACK FOOTER //
// ./src/components/common/PDFWindow.tsx